<template>
<div>
    <v-card class="pt-4" flat v-if="giftsCnt">
        <v-card-title class="px-0">Подарунки:</v-card-title>
        <v-card-text class="px-0">
            <div v-for="(action, action_id) in list" :key="action_id">
                <a target="_blank" :href="`/action/${action_id}`">{{action.actionName}}</a>
                <v-list>
                    <div v-for="(prodset, prodset_id) in action.items" :key="prodset_id">
                        <v-list-item class="px-0" v-for="(item, group_id) in action.items[prodset_id]" :key="group_id" @click="openLink(item.typhoon_id)">
                            <v-list-item-avatar class="align-self-start">
                                <v-img :src="image(item.smallimg)" :lazy-src="nophoto"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content class="pa-0">
                                    <v-list-item-action-text v-text="item.name_ukr" :title="item.name_ukr" class="font-weight-regular subtitle-2 link--text" style="cursor: pointer;"></v-list-item-action-text>
                            </v-list-item-content>
                            <v-list-item-action class="align-self-center">
                                {{item.qty_total}} шт
                            </v-list-item-action>
                    </v-list-item>
                    </div>
                </v-list>

            </div>
        </v-card-text>
         <!-- <pre>{{list}}</pre> -->
         <!-- <pre>{{shoppingCartGiftsData}}</pre> -->
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

export default {
    components: {

    },
    props: {},
    data() {
        return {
            nophoto: 'data:image/png;base64,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',
        }

    },
    methods: {
        ...mapActions([]),
        image(img) {
            return img ? img : this.nophoto
        },
        goTo(item) {
            this.$router.push('/product/' + item.typhoon_full_id)
            this.$store.commit('setShoppingCartDialog', false)
        },
        isMultiCond(item) {
            return this.type == 'available' && item.act_qty > 1 //&& item.single_act_cond == 0
        },
        checkMultiCond(item) {
            if (item.typhoon_check_lot) {
                return item.totalCnt < item.act_qty ? true : false
            } else {
                return item.totalCnt % item.act_qty ? true : false
            }
        },
        openLink(typhoon_id){
            let routeData = this.$router.resolve({path: `/product/${typhoon_id}`});
            window.open(routeData.href, '_blank');            
        }
    },
    created() {},
    computed: {
        shoppingCartGiftsData: {
            get: function () {
                return this.$store.state.catalog.shoppingCartGiftsData
            },
            set: function (v) {
                this.$store.commit('setShoppingCartGiftsData', v)
            }
        },
        list() {
            const list = {}
            for (let prodset_id in this.shoppingCartGiftsData) {
                for (let group_id in this.shoppingCartGiftsData[prodset_id]) {
                    const el = this.shoppingCartGiftsData[prodset_id][group_id]
                    if (!list[el.action_id]) {
                        list[el.action_id] = {
                            actionName: el.action_name,
                            items: {}
                        }
                    }
                    if (!list[el.action_id].items[prodset_id]) {
                        list[el.action_id].items[prodset_id] = {}
                    }
                    if (!list[el.action_id].items[prodset_id][group_id] /*&& el.qty_total*/ ) {
                        list[el.action_id].items[prodset_id][group_id] = el
                    }
                }
            }
            return list
        },
        giftsCnt() {
            let cnt = 0
            for (let prodset_id in this.shoppingCartGiftsData) {
                for (let group_id in this.shoppingCartGiftsData[prodset_id]) {
                    cnt += 1
                }
            }
            return cnt
        }
    },
    watch: {},
}
</script>

<style scoped>
</style>
